import React from "react";
import ReactTooltip from "react-tooltip";
import { Link } from "react-router-dom";

const portfolioContent = [
  {
    cat: "Appentwicklung",
    title: "Sauter Bäckerei",
    date: "2023",
    routerLink: "/portfolio-details",
    imgPopup: "work1",
    dataId: "work-1",
  },
  {
    cat: "Webseite",
    title: "Unternehmensinitiative",
    date: "2024",
    routerLink: "/portfolio-details",
    imgPopup: "work2",
    dataId: "work-2",
  },
  {
    cat: "Branding",
    title: "Freiberufler Softwareentwicklung",
    date: "2023",
    routerLink: "/portfolio-details",
    imgPopup: "work3",
    dataId: "work-3",
  },
];

const PortfolioTwo = () => {
  return (
    <>
      <div className=" grid-item ">
        {/* <!--Portfolio Item--> */}
        {portfolioContent.map((val, i) => (
          <article
            className="ptf-work ptf-work--style-4"
            data-tip
            data-for={val.dataId}
            key={i}
          >
            {/* <Link className="ptf-work__link" to="/works-showcase"></Link> */}
            <ReactTooltip
              id={val.dataId}
              place="right"
              type="dark"
              effect="float"
            >
              <div className="poup-link">
                <img
                  src={`assets/img/portfolio/grid/${val.imgPopup}.png`}
                  alt="popup"
                />
              </div>
            </ReactTooltip>
            <div className="ptf-work__category">{val.cat}</div>
            <h4 className="ptf-work__title">{val.title}</h4>
            <div className="ptf-work__date">{val.date}</div>
          </article>
        ))}
      </div>
      {/* End .grid-item */}
      <div></div>
      {/* End .grid-item */}
    </>
  );
};

export default PortfolioTwo;
